/**
 * Created by ren on 31/05/2017.
 */
export const capitalize = ( string ) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
export const SYSTEM_DEFAULT = 'system_default';
export const ACCOUNT = 'account';
export const SUBSIDIARY = 'subsidiary';
export const LOCATION = 'location';
export const EMPLOYEE = 'employee';

export const SYSTEM_PREFERENCES = [
    { id : ACCOUNT, name : capitalize( ACCOUNT) },
    { id : SUBSIDIARY, name : capitalize( SUBSIDIARY ) },
    { id : LOCATION, name : capitalize( LOCATION ) }
];

export const BOOLEAN = 'Boolean';
export const NUMERIC = 'Numeric';
export const STRING = 'String';
export const OBJECT = 'Object';

export const INHERIT = 'inherit';
export const INHERIT_OBJECT = { id: 'inherit', name : 'Inherit' };
export const BOOLEAN_LIST = [ { id: true, name : 'True' }, { id: false, name : 'False' } ];

